import styled from 'styled-components';
export const PlaceholderContainer = styled.div.withConfig({
  displayName: "paginatedGallerycss__PlaceholderContainer",
  componentId: "sc-572ul0-0"
})(["display:flex;flex-wrap:wrap;gap:2px;margin:8px;width:calc(100% - 16px);"]);
export const PlaceholderTile = styled.div.withConfig({
  displayName: "paginatedGallerycss__PlaceholderTile",
  componentId: "sc-572ul0-1"
})(["flex:1 1 calc(33.333% - 2px);height:", "px;background-color:#e0e0e0;border-radius:4px;"], props => props.$targetRowHeight || 260);